export default __webpack_public_path__ + "static/media/client1.23992f43.jpg";